<style scoped>
.worklist {
	margin: 5px;
	box-shadow: 2px 2px 4px gray;
}

.worklist_title {
	font-size: 16px;
	color: black;
	overflow: hidden;
}
</style>

<template>
	<v-card class="worklist">
		<v-card-text class="px-2 py-2">
			<!-- <suitcase_icon style="float:left;position: relative;top:10px" opacity="0.6"/> --> 

			<div style="overflow: hidden;" class="ml-1">
				<div 
					style="float: right" 
					class="ml-1 worklist_links" 
					v-if="worklist.is_owned" @click.prevent="$emit('rename', worklist)"
				>
					Rename
				</div>
				<div 
					style="float: right" 
					class="ml-1 worklist_links" 
					v-if="worklist.is_owned" 
					@click.prevent="$emit('delete', worklist)"
				>
					Del
				</div>
				<div style="float: right" class="ml-1" v-if="!worklist.is_owned && worklist.is_hidden" @click.prevent="set_hidden(false)">Unhide</div>
				<div style="float: right" class="ml-1" v-if="!worklist.is_owned && !worklist.is_hidden" @click.prevent="set_hidden(true)">Hide</div>
				<div style="float: right" class="ml-1" v-if="worklist.is_pinned" @click.prevent="set_pinned(false)">UnPin</div>
				<div style="float: right" class="ml-1" v-if="!worklist.is_pinned" @click.prevent="set_pinned(true)">Pin</div>
				<div class="worklist_title" @click.prevent="do_click()">
					<span><b>{{ worklist.name }}</b></span>
					<span v-if="!worklist.is_owned">, owned by {{ worklist.owner }}</span>
					<span v-if="worklist.is_dynamic">, dynamic</span>
				</div>
				<div style="clear: right"></div>
			</div>

			<div style="clear:left">
			</div>
		</v-card-text>
	</v-card>	
</template>

<script>
// import suitcase_icon from "@/components/icons/suitcase"

export default {
	props: {
		worklist: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			test: false
		}
	},
	computed: {

	},
	methods: {
		do_click() {
			this.$emit('click', this.worklist.id)
		},
		set_hidden(hide) {
			let self = this;

			axios
				.put("/api/worklists/" + this.worklist.id + "/hidden", {
					enabled: hide
				}, {
					"Authorization": "Bearer " + self.$store.state.token,
					"Accept": "application/json"				
				})
				.then(function(d) {
					// Don't ask me why it does work here... 
					let json = d.data;

					if (json.status == "OK") {
						console.log("got data");

						// close dialog
						self.visible = false

						// let the world know
						self.$emit('changed_hidden', self.worklist.id);
					} else {
						// self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					// self.errormsg = e.message;
				});
		},
		set_pinned(pinned) {
			let self = this;

			axios
				.put("/api/worklists/" + this.worklist.id + "/pinned", {
					enabled: pinned
				}, {
					"Authorization": "Bearer " + self.$store.state.token,
					"Accept": "application/json"				
				})
				.then(function(d) {
					// Don't ask me why it does work here... 
					let json = d.data;

					if (json.status == "OK") {
						console.log("got data");

						// close dialog
						self.visible = false

						// update store..
						if (self.worklist.class == 'restful.jobs.worklists') {
							self.$store.dispatch('update_pinned_job_worklists');
						} else if (self.worklist.class == 'restful.addressbook.worklists') {
							self.$store.dispatch('update_pinned_abook_worklists');
						} else if (self.worklist.class == 'restful.tasks.lists') {
							self.$store.dispatch('update_pinned_tasks_worklists');
						}

						// let the world know
						self.$emit('changed_pinned', self.worklist.id);
					} else {
						// self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					// self.errormsg = e.message;
				});
		}
	}
}
</script>